import React, { useEffect, useRef, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';

import { ADSENSE } from 'shared/settings/config';
import { getItemUrl, mergeItemPreviousNextInSessionStorage, setItemPreviousNextInSessionStorage } from 'shared/utils/utils';
import { Adsense } from 'shared/utils/Adsense';
import { Loader } from 'shared/hoc/loader/Loader';
import PaginationHOC from './PaginationHOC';
import ItemCard from './ItemCard';
import { ItemsService } from 'shared/services';
import { bidEventManager } from 'shared/sse/SSEManager';

import "./paginationhoc.scss";

const PaginationListHOC = ({ config = {}, emptyCont, renderContent = null, onRestCall = null, showAd }) => {

    const dispatch = useDispatch()

    const user = useSelector(state => state.user);
    const statemaintenance = useSelector(state => state?.statemaintenance);

    const [rowcount, setrowcount] = useState(config?.count)
    const [DataList, setlist] = useState([])
    const [isPageLoad, setpageLoad] = useState(true)
    const [pages, setpages] = useState([])
    const [watchlist, setwatchlist] = useState([]);
    const [currentBidList, setCurrentBidList] = useState([]);
    const [biddingData, setbiddingData] = useState([])
    const [screenwidth, setscreenwidth] = useState(window.innerWidth)

    const parentRef = useRef(null);
    const pagekey = useRef({
        total: null,
        next: null,
        previous: null
    })
    const currentindex = useRef(1)
    const totalrecord = useRef(0)

    useEffect(() => {
        getWidth()
        window.addEventListener('resize', () => {
            getWidth()
        });
        pagekey.current ={
            ...pagekey.current,
            next: null,
            previous: null,
        }
        if (config?.payload) {
            // let data = statemaintenance
            // delete data?.[config?.heading]
            // dispatch({
            //     type: 'PUSH_TO_STATE', payload: data
            // });
            if (config?.heading && statemaintenance?.[config?.heading] && !config?.horizontailView) {
                let screenState = statemaintenance?.[config?.heading]
                if (screenState?.currentPage != currentindex.current) {
                    pagekey.current = screenState?.pagekey
                    currentindex.current = screenState?.previousPage
                    totalrecord.current = screenState?.pagekey?.total
                    getApiData(screenState?.currentPage)
                } else {
                    totalrecord.current = 0
                    currentindex.current = 1
                    getApiData(null)
                }


            } else {
                totalrecord.current = 0
                currentindex.current = 1
                getApiData(null)
            }
        }
        return () => {
            window.removeEventListener('resize', () => getWidth());
            bidEventManager.ignore();
        }
    }, [config?.payload]);

    useEffect(() => {
        if ( config.type === 'StaticItem' && Array.isArray(config.list) && config.list.length > 0 ) {
            setlist(config.list);
            let ids = config.list.map(item => item.id ? item.id : item.itemid);
            getBidValues(ids);
            if (user.id) {
                getWatchList(ids);
            }

            bidEventManager.connect(ids, config.appendIdsForBidListening ? true : false);
        }
    }, [config.list]);

    useEffect(() => {
        if ( user.id && DataList.length > 0 ) {
            getWatchList(DataList.map(item => item.id || item.itemid));
        }
    }, [user.id]);
    
    const getApiData = (key = null) => {
        let payload = {...config?.payload}
        delete payload["page"]["previous"]
        delete payload["page"]["next"]
        delete payload["page"]["total"]
        delete payload["page"]["from"]
        delete payload["page"]["to"]
        if (key != null) {
            if (key == currentindex.current + 1 && pagekey.current?.next != null) {
                payload["page"]["next"] = pagekey.current?.next
            } else if (key == currentindex.current - 1 && pagekey.current?.previous != null) {
                payload["page"]["previous"] = pagekey.current?.previous
            } else {
                payload["page"].total = pagekey.current?.total;
                payload["page"].from = currentindex.current;
                payload["page"].to = key;

                if (key > currentindex.current) {
                    payload["page"]["next"] = pagekey.current?.next
                } else {
                    payload["page"]["previous"] = pagekey.current?.previous
                }
            }
        }
        setpageLoad(true)
        if (config?.heading  && !config?.horizontailView) {
            let pusttoStore = { ...statemaintenance }
            pusttoStore[config?.heading] = {
                ...pusttoStore?.[config?.heading],
                pagekey: pagekey.current,
                currentPage: key,
                previousPage:currentindex.current
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
        currentindex.current = key != null ? key : 1
        switch (config?.type) {
            case "Item":
                ItemsService?.[config?.searchType ? "itemsNLPSearch" : "getItemsList"](payload).then(async (response) => {
                    setApiData(response)
                    let list = response?.data?.data
                    let ids = list.map(item => item.id ? item.id : item.itemid)
                    if (ids.length > 0) {
                        getBidValues(ids)
                        if (user.id) {
                            getWatchList(ids)
                        }

                        bidEventManager.connect(ids);
                    }

                }).catch((error) => {
                    setpageLoad(false)
                });
                break;
            case "WatchList":
                ItemsService.getWatchList(payload).then(async (response) => {
                    if (response?.data?.data?.length > 0) {
                        let data = response?.data?.data;
                        let watchids = data.map(item => item.itemid);

                        const itemPayload = {
                            // "sort": [{ "field": "bidprice", "direction": "asc" }],
                            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime",
                                "utc", "title", "endtime", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl'],
                            "filter": [
                                { "field": "id", "value": [watchids], "op": "IN", "join": "AND" }
                            ],
                        };
                        ItemsService.getItemsList(itemPayload).then(async (resp) => {

                            let watchListData = [];
                            data.map(watchItem => {
                                const item = resp.data.data.find(item => watchItem.itemid == item.id);
                                if ( item ) {
                                    watchListData.push({...watchItem, ...item});
                                }
                            });

                            let ids = watchListData.map(item => item.itemid || item.id);
                            bidEventManager.connect(ids);
                            onRestCall({ totalid: ids });
                            setwatchlist(watchListData);
                            response.data.data = watchListData;
                            setApiData(response);
                            setlist(watchListData)

                            if (ids.length > 0) {
                                getBidValues(ids)
                            }

                            setpageLoad(false)
                        }).catch((error) => {
                            setpageLoad(false)
                        });
                    } else {
                        setApiData(response)
                        onRestCall({ totalid: [] })
                    }
                }).catch((error) => {
                    setpageLoad(false)
                });
                break
            case "Bidding":
                ItemsService.getBidding(payload).then(async (response) => {
                    if (response?.data?.data?.length > 0) {
                        let data = response?.data?.data
                        let bidids = data.map(item => item.itemid)
                        const itemPayload = {
                            // "sort": [{ "field": "endtime", "direction": "asc" }],
                            "field": ["id", "displayimageurl", "itemstatus", "itemtypeid", "itemtypename", "itemclosetime",
                                "utc", "title", "endtime", "isshippable", "saleid", "category", 'categoryGroup', 'thumbnailurl', 'itemseourl'],
                            "filter": [{ "field": "id", "value": [bidids], "op": "IN", "join": "AND" }, { "field": "itemstatus", "value": "Pending", "op": "!=", "join": "AND" }],
                        };
                        setbiddingData(data)

                        bidEventManager.connect(bidids);

                        ItemsService.getItemsList(itemPayload).then(async (resp) => {
                            let bidItem = response?.data?.data.map((item, index) => {
                                let bidData = resp?.data?.data.find(b => b.id == item?.itemid);
                                if ( bidData ) {
                                    response.data.data[index] = {...item, ...bidData};
                                }
                                return (bidData)
                            })
                            setApiData(response)
                            setlist(bidItem)
                            let ids = bidItem.map(item => item.id ? item.id : item.itemid)
                            getBidValues(ids)
                            if (ids.length > 0) {
                                if (user.id) {
                                    getWatchList(ids)
                                }
                            }

                        }).catch((error) => {
                            setpageLoad(false)
                        });
                    } else {
                        setApiData(response)
                    }
                }).catch((error) => {
                    setpageLoad(false)
                });
                break
            default:
                break;
        }
    }

    const setApiData = (resp) => {
        try {
            let list = resp?.data?.data
            setlist(list)
            let total = totalrecord.current 
            if (resp?.data?.page?.total > 0) {
                total = resp?.data?.page?.total
            } else if (!(resp.data.page)) {
                total = list?.length
            }
            if (onRestCall != null) {
                onRestCall(total)
            }
            if (total) {
                totalrecord.current = total
            }
            pagekey.current =  {
                total: resp?.data?.page?.total ? resp?.data?.page?.total : total ? total : pagekey.current.total ? pagekey.current.total : null,
                next: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.next ? resp.data.page.keyset.next : null,
                previous: resp.data.page && resp.data.page.keyset && resp.data.page.keyset.previous ? resp.data.page.keyset.previous : null,
            }
            setpageLoad(false)
        if (!config?.horizontailView) {
            const scrollContainer = document.querySelector('.scroll-content');
            if (scrollContainer) {
                if(statemaintenance?.[config?.heading]?.scrollindex) {
                    scrollContainer.scrollTop =  statemaintenance?.[config?.heading]?.scrollindex
                    // scrollContainer.scrollTo({ top: statemaintenance?.[config?.heading]?.scrollindex, left: 0, behavior: 'smooth' });
                } else {
                    scrollContainer.scrollTop = 0;
                }
            } else {
                window.scrollTo(0, 0);
            }
        }
        } catch (error) {
            setpageLoad(false)

        }
    }
    useEffect(() => {
        let pageList = [];
        if (Number(totalrecord.current) > 0) {
            let count = Math.ceil(totalrecord.current / config?.pageSize)
            const left = currentindex.current == count ? currentindex.current - 4 : currentindex.current - 2;
            const right = currentindex.current > 2 ? currentindex.current + 2 : currentindex.current + 4;

            for (let i = 1; i <= count;) {
                if (i === 1 || i === count || (i >= left && i <= right)) {
                    pageList.push(i);
                } else {
                    if (pageList[pageList.length - 1] !== '⋯') {
                        pageList.push('⋯');
                    }
                }
                i++
            }
        }
        setpages([...pageList])
    }, [totalrecord.current, currentindex.current, DataList])

    const getWidth = () => {
        let width = window?.innerWidth
        setscreenwidth(width)
        let countInRow = config.count
        if (countInRow >= 4) {
            countInRow = width > 1200 ? config.count : width > 900 ? config.count - 1 : width > 600 ? config.count - 2 : config.count - 3
        } else if (countInRow == 3) {
            countInRow = width > 1000 ? 3 : width > 800 ? 2 : 1
        } else if (countInRow == 2) {
            countInRow = width > 800 ? 2 : 1
        }
        setrowcount(countInRow)
        const container = parentRef.current;
        if (container) {
            // container?.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }
    }

    const recallwatchlist = () => {
        let itemids = DataList.map(item => item.id ? item.id : item.itemid)
        getWatchList(itemids)
    }
    const getWatchList = async (ids) => {
        const data = {
            "sort": [{ "field": "id", "direction": "desc" }],
            "filter": [{ "field": "itemid", "value": [ids], "op": "IN", "join": "AND" }],
            "field": ["itemid"],
        };
        await ItemsService.getWatchListItem(data).then(
            response => {
                setwatchlist(response.data.data)

            }
        ).catch(error => {
        });
    }
    const getBidValues = async (ids) => {
        const data = {
            "data": {
                "itemIds": ids
            }
        };
        await ItemsService.getCurrentBidValue(data).then(
            response => {
                setCurrentBidList(response.data.data);
            }
        ).catch(error => {
        })
    }

    const overAllClick = (item, index) => {
        const scrollContainer = document.querySelector('.scroll-content');
        if (config?.heading  && !config?.horizontailView) {
            let pusttoStore = { ...statemaintenance }
            pusttoStore[config?.heading] = {
                ...pusttoStore?.[config?.heading],
                scrollindex:scrollContainer.scrollTop
            }
            dispatch({
                type: 'PUSH_TO_STATE', payload: pusttoStore
            });
        }
        
        let itemid = item?.id || item?.itemid;
        if ( config.type === 'StaticItem' ) {
            mergeItemPreviousNextInSessionStorage(DataList, index);
            config?.history.replace(getItemUrl(item.saleid, itemid, item.itemseourl));
        } else {
            setItemPreviousNextInSessionStorage(DataList, index);
            config?.history.push(getItemUrl(item.saleid, itemid, item.itemseourl));
        }
    }

    const renderItem = (item, index) => {
        // const scrollContainer = document.querySelector('.scroll-content');
        // if (scrollContainer) {
        //     scrollContainer.scrollTop = 0;
        // } else {
        //     window.scrollTo(0, 0);
        // }
        switch (config?.type) {
            case "Item":
                return (
                    <ItemCard items={item}
                        currentBids={currentBidList}
                        watch={watchlist}
                        bidnow={() => { overAllClick(item, index) }}
                        recallWatchList={recallwatchlist}
                    />
                )
            case "StaticItem":
                return (
                    <ItemCard items={item}
                        currentBids={currentBidList}
                        watch={watchlist}
                        bidnow={() => { overAllClick(item, index) }}
                        recallWatchList={recallwatchlist}
                    />
                )
            case "Bidding":
                return (
                    <ItemCard items={item}
                        currentBids={currentBidList}
                        watch={watchlist}
                        bidnow={() => { overAllClick(item, index) }}
                        recallWatchList={recallwatchlist}
                        type={"Bidding"}
                        extra={biddingData.filter(i => i?.itemid == item?.id)?.[0] || {}}
                    />
                )
            case "WatchList":
                return (
                    <ItemCard items={item}
                        currentBids={currentBidList}
                        watch={watchlist}
                        bidnow={() => { overAllClick(item, index) }}
                        recallWatchList={getApiData}
                        type={"WatchList"}
                        extra={{
                            selectedList: config?.selectedList,
                            onselect: () => {
                                onRestCall({ "id": item?.id })
                            }
                        }}
                    />
                )
            default:
                return (<div></div>)
        }
    }
    if (config?.horizontailView) {
        return (
            <div className='paginationhoc'>
                {DataList.length > 0 && <div className='view-more-item w-100'>{config?.title}</div>}
                <PaginationHOC
                    list={DataList}
                    renderItem={(item, index) => {
                        return renderItem(item, index)
                    }}
                    notitle={true}
                    count={4}
                    leftright={true}
                />
            </div>

        )
    }
    return (
        <div className={"paginationhoc flex-grow-1"} ref={parentRef} >
            {
                isPageLoad ? 
                <Loader /> : 
                <div className="pageView flex-grow-1">
                    {
                        DataList.length > 0 ? 
                        <> 
                            <Row xs={2} sm={2} md={2} lg={rowcount} className='flex-grow-1'>
                                {
                                    DataList.map((item, index) => (
                                        <>
                                            {
                                                window.innerWidth <= 1000 ? 
                                                    config.type == "Item" ? ADSENSE.ENABLE && showAd && index !== 0 && index % 16 === 0 ?
                                                    <Adsense googleAdCenter slotId={ADSENSE.ITEM_SEARCH.slotId} />  : '' : ''
                                                : 
                                                    config.type == "Item" ? ADSENSE.ENABLE && showAd && index !== 0 && index % 15 === 0 ?
                                                    <Adsense googleAdCenter slotId={ADSENSE.ITEM_SEARCH.slotId} />  : '' : ''
                                            }
                                            <Col className='listitem' id={"cardid"}>
                                                {renderItem(item, index)}
                                            </Col>
                                        </>
                                    ))
                                }
                            </Row>

                            <div className='pagination'>
                                {
                                    pages.length > 1 && pages.map((page, index) => (
                                        <div
                                            role={typeof page === 'number' ? "button" : "none"}
                                            className={`page-button ${currentindex.current === page ? 'active' : ''}  ${page !== '⋯' ? 'borderbox' : 'dotbox'}`}
                                            onClick={() => {
                                                if (typeof page === 'number') {
                                                    getApiData(page)
                                                }
                                            }}
                                        >{page}</div>
                                    ))
                                }
                            </div>
                        </> : 
                        <div className='empty-cont' style={{ fontSize: "18px" }}>{emptyCont}</div>
                    }
                </div>
            }

        </div>
    );
};

export default PaginationListHOC;

